import { useCallback, useEffect, useRef } from 'react'

function useAutosave({ saveFunction = async () => {}, trigger = false }, dependencyArray = []) {
  const isAutosaving = useRef(false)
  const isSavedRef = useRef(false)

  const save = useCallback(async () => {
    if (!isAutosaving.current && !isSavedRef.current) {
      isAutosaving.current = true
      await saveFunction()
      isAutosaving.current = false
      isSavedRef.current = true
    }
  }, dependencyArray)

  useEffect(() => {
    isSavedRef.current = false
    if (trigger) {
      save()
    }
  }, [trigger])

  return {
    isAutoSaving: isAutosaving.current,
  }
}

export default useAutosave
